import { db } from "@/indexedDB/db";
import { LinkEntity } from "../types";

// Add link
export const addLinkToLocalDB = async (link: LinkEntity) => {
  return await db.links.put(link);
};

// Bulk add link list
export const addLinksToLocalDB = async (linkList: LinkEntity[]) => {
  return await db.links.bulkPut(linkList);
};

// Update link by id (id = message id)
export const updateLinkInLocalDB = async (
  id: string,
  link: Partial<LinkEntity>,
) => {
  return await db.links.update(id, link);
};

// Get links by chat id
export const getLinksByChatIdFromLocalDB = async (chatId: string) => {
  return await db.links
    .where("chatId")
    .equals(chatId)
    .reverse()
    // TO DO => check if custom index needed for better query perf (infinite scroll + virtual list)
    .sortBy("timestamp");
};

// get link by id
export const getLinkByIdFromLocalDB = async (id: string) => {
  return await db.links.get(id);
};

// Remove link by id
export const deleteLinkByIdFromLocalDB = async (id: string) => {
  return await db.links.delete(id);
};

// Get paginated links by chatId with a limit
export const getPaginatedLinksByChatIdFromLocalDB = async (
  chatId: string,
  limit: number,
) => {
  return await db.links
    .where("chatId")
    .equals(chatId)
    .limit(limit)
    .reverse() // Reverse the order to get newest first
    .sortBy("timestamp");
};

// Get total link count by chatId
export const getLinkCountByChatIdFromLocalDB = async (chatId: string) => {
  return await db.links
    .where("chatId")
    .equals(chatId)
    .count()
    .then((count) => count);
};
